import React, {useMemo} from "react";
import {FormattedMessage} from "react-intl";
import {flagStyleMap} from "@widgets/pos/order/menu/product/flags/flags";
import {Badge} from "peggirkit";

type Props = {
    name: string,
};

const ProductFlag = ({name}: Props) => {
    const {style} = useMemo(() => flagStyleMap[name], [name]);

    return (
        <li>
            <Badge
                color={style}
                size={"xs"}
            >
                <FormattedMessage id={`flag.${name}`}/>
            </Badge>
        </li>
    );
};

export default ProductFlag;